import { useState, useEffect, useRef } from "react";
import useAccountManagementStore from "../../../stores/accountManagementStore";

export function useFormCooldown(cooldownSeconds: number = 2) {
    const [canSubmit, setCanSubmit] = useState(true);
    const cooldownTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const lastSubmitTime = useAccountManagementStore((state) => state.lastSubmitTime);
    const setLastSubmitTime = useAccountManagementStore((state) => state.setLastSubmitTime);
    const canSubmitGlobal = useAccountManagementStore((state) => state.canSubmit(1000));

    useEffect(() => {
        if (!canSubmitGlobal && canSubmit) {
            setCanSubmit(false);
            const timer = setTimeout(() => {
                setCanSubmit(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [lastSubmitTime]);

    const startCooldown = () => {
        setLastSubmitTime(Date.now());
        setCanSubmit(false);

        if (cooldownTimeoutRef.current) {
            clearTimeout(cooldownTimeoutRef.current);
        }

        const timer = setTimeout(() => {
            setCanSubmit(true);
        }, cooldownSeconds * 1000);

        cooldownTimeoutRef.current = timer;
    };

    const resetCooldown = () => {
        if (cooldownTimeoutRef.current) {
            clearTimeout(cooldownTimeoutRef.current);
            cooldownTimeoutRef.current = null;
        }
        setCanSubmit(true);
    };

    return { canSubmit, startCooldown, resetCooldown };
}
